import {
  orgID,
  websiteID,
  traceID,
  sessionID,
  apiDomain,
  RenderMode,
} from "../../settings";
import {
  AdBlockerType,
  PageViewEventType,
  SoftwallRecoveredType,
} from "../types";
import { RL_PREVIEW } from "./queryParams";

type SoftwallBaseEvent = {
  recoveryType?: SoftwallRecoveredType;
  detectedExtension: AdBlockerType;
};

export type SoftwallDismissEvent = {
  event: "dismiss";
  element: "x-button" | "continue-to-site" | "refresh-button";
  tab?: AdBlockerType;
} & SoftwallBaseEvent;

type SoftwallRenderedEvent = {
  event: "rendered";
  renderMode: RenderMode;
} & SoftwallBaseEvent;

type SoftwallRecoveredEvent = {
  event: "recovered";
} & SoftwallBaseEvent;

type SoftwallFlattrEvent = {
  event: "flattr";
} & SoftwallBaseEvent;

type SoftwallNavigateAwayEvent = {
  event: "navigate-away";
  renderMode: RenderMode;
} & SoftwallBaseEvent;

type SoftwallPrimaryCtaRedirectEvent = {
  event: "primary-cta-redirect";
} & SoftwallBaseEvent;

type SoftwallSecondaryCtaRedirectEvent = {
  event: "secondary-cta-redirect";
} & SoftwallBaseEvent;

type SoftwallPageViewEvent = {
  event: PageViewEventType;
  consentMessageShown?: boolean;
  attributionExpired?: boolean;
} & SoftwallBaseEvent;

type SoftwallRestoredFromServerEvent = {
  event: "restored-from-server";
} & SoftwallBaseEvent;

type SoftWallKVPSetTrackingEvent = {
  event: "kvp";
  meta: {
    latency: number;
  };
} & SoftwallBaseEvent;

type SoftwallSCARejectEvent = {
  event: "sca-timeout" | "sca-error";
} & SoftwallBaseEvent;

export type SoftwallEvent =
  | SoftwallDismissEvent
  | SoftwallRenderedEvent
  | SoftwallRecoveredEvent
  | SoftwallFlattrEvent
  | SoftwallPageViewEvent
  | SoftwallNavigateAwayEvent
  | SoftwallPrimaryCtaRedirectEvent
  | SoftwallSecondaryCtaRedirectEvent
  | SoftwallRestoredFromServerEvent
  | SoftWallKVPSetTrackingEvent
  | SoftwallSCARejectEvent;

type MWEventRequest = {
  orgID: number;
  traceID: string;
  websiteID: number;
  event: string;
  sessionID?: string;
  meta?: unknown;
  element?: string;
  recoveryType?: string;
  detectedExtension: string;
  scriptVersion: string;
  scriptLoadingMode: string;
};

export async function sendEvent(event: SoftwallEvent) {
  if (RL_PREVIEW) {
    return; // Prevent sending events in preview mode
  }

  const defaultMeta = {
    pageURL: window.location.href,
    ["abtest-presentation-version"]: window.__bt_tag_am.settings.view,
  };

  return callEventsAPI({
    traceID,
    sessionID,
    orgID: Number(orgID),
    websiteID: Number(websiteID),
    scriptVersion: __SCRIPT_VERSION__,
    scriptLoadingMode: window.__bt_rlink_loaded_from_tag
      ? "inject_from_tag_script"
      : "standalone",
    ...event,
    meta: "meta" in event ? { ...defaultMeta, ...event.meta } : defaultMeta, // allow custom meta for different events
  });
}

async function callEventsAPI(request: MWEventRequest) {
  return fetch(`https://${apiDomain}/events/mw`, {
    method: "POST",
    body: JSON.stringify(request),
    headers: {
      "Content-Type": "application/json",
    },
    mode: "no-cors",
    keepalive: true,
  });
}
